import { useEffect, useState } from "react";
import { formatIndianPriceWithComa } from "../../../../../utils/formatIndianPrice2";

const PaymentModal = ({ show, onClose, totalamount, type, fulldata, error, onConfirmPayment, paymentDetails, totalamountwithDiscount }) => {
  const [amountPaid, setAmountPaid] = useState("");
  const [upiid, setupiid] = useState("");
  const [cardno, setcardno] = useState("");
  const [CRN, setCRN] = useState("");
  const [CRD, setCRD] = useState("");
  const [OldGold, setOldGold] = useState("");
  const [totalValue, setTotalValue] = useState(0);

  
  useEffect(() => {
      setTotalValue(totalamountwithDiscount);
  }, [totalamountwithDiscount]);




const handleNumberClick = (num) => {
  const newAmount = (amountPaid + num).replace(/^\./, "0.");
  setAmountPaid(newAmount);
};

const handleConfirm = () => {
  const numericValue = parseFloat(amountPaid || 0);
  let finalAmount = (parseFloat(totalValue) + parseFloat(paymentDetails[type].amount));
  if (numericValue > Math.round(finalAmount) && numericValue != Math.round(finalAmount)) {
    error.seterrorMessage(`Amount Paid cannot be higher than Total Value!`);
    error.seterrorType("Error");
    error.setisErrorVisible(true);
    return;
  }

  if (type === "UPI") {
    if (!upiid.trim()) {
      error.seterrorMessage("UPI ID is required!");
      error.seterrorType("Error");
      error.setisErrorVisible(true);
      return;
    }
  }

  if (type === "CreditCard") {
    if (!cardno.trim()) {
      error.seterrorMessage("Card Number is required!");
      error.seterrorType("Error");
      error.setisErrorVisible(true);
      return;
    }

    if (cardno.length < 12) {
      error.seterrorMessage("Enter a valid Card Number!");
      error.seterrorType("Error");
      error.setisErrorVisible(true);
      return;
    }
  }

  if (type === "Cheque") {
    if (!CRN.trim()) {
      error.seterrorMessage("Cheque Reference Number is required!");
      error.seterrorType("Error");
      error.setisErrorVisible(true);
      return;
    }

    if (!CRD.trim()) {
      error.seterrorMessage("Cheque Reference Date is required!");
      error.seterrorType("Error");
      error.setisErrorVisible(true);
      return;
    }
  }

  if (type === "Old Gold") {
    if (!OldGold.trim()) {
      error.seterrorMessage("Account Paid To is required!");
      error.seterrorType("Error");
      error.setisErrorVisible(true);
      return;
    }
  }

  const previousData = paymentDetails[type] || {};

  const paymentData = {
    type,
    data: {
      ...previousData,
      amount: numericValue,
      ...(type === "UPI" && { upiId: upiid }),
      ...(type === "CreditCard" && { cardNo: cardno }),
      ...(type === "Cheque" && { cheque_reference_no: CRN, cheque_reference_date: CRD }),
      ...(type === "Old Gold" && { accountPaidTo: OldGold }),
    },
  };

  if (typeof onConfirmPayment === "function") {
    onConfirmPayment(paymentData);
  }

  onClose();
};



  const handleBackspace = () => setAmountPaid((prev) => prev.slice(0, -1));
  const numericAmount = parseFloat(amountPaid || 0);


  useEffect(() => {
    if (show && paymentDetails && type) {
      const data = paymentDetails[type] || {};
      setAmountPaid(data.amount > 0 ? String(data.amount) : "");
      setupiid(data.upiId || "");
      setcardno(data.cardNo || "");
      setCRN(data.cheque_reference_no || "");
      setCRD(data.cheque_reference_date || "");
      setOldGold(data.accountPaidTo || "");
    }
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content rounded-3 shadow-sm border-0">
          <div
            className="modal-header py-2 px-3"
            style={{ borderBottom: "0px" }}
          >
            <h5 className="modal-title fw-semibold" style={{ fontSize: "18px" }}>
              Payment Entry
            </h5>
            <button
              type="button"
              style={{ fontSize: "14px" }}
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body px-4 pb-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <p className="m-0 fw-medium">Mode of Payment <span className="badge bg-light ms-1" style={{color:'#616A87'}}>{type}</span></p>
              <p className="m-0 fw-medium">
                Customer Name <span style={{ color: "#5973C7" }}>{fulldata.customer}</span>
              </p>
            </div>

            {/* Amount Section */}
            <div className="row g-3">
              <div className="col-md-6">
                <div className="d-flex justify-content-between p-3 rounded-3" style={{ background: "#FFF5E1" }}>
                  <p className="m-0 fw-medium">Total Value</p>
                  <h5 style={{fontSize:'18px'}} className="m-0 text-success">₹{formatIndianPriceWithComa(parseFloat(totalamount).toFixed(2))}</h5>
                </div>

                <div className="d-flex justify-content-between p-3 rounded-3 mt-3" style={{ background: "#F6E6FF" }}>
                  <p className="m-0 fw-medium">Amount Paid</p>
                  <h5 className="m-0" style={{ color: "#C2185B",fontSize:'18px' }}>
                    ₹{formatIndianPriceWithComa(numericAmount.toFixed(2))}
                  </h5>
                </div>

                <div className="d-flex justify-content-between p-3 rounded-3 mt-3" style={{ background: "#E5E8FF" }}>
                  <p className="m-0 fw-medium">Balance Paid to Customer</p>
                  <h5 className="m-0 text-primary" style={{fontSize:'18px'}} >
                    ₹{formatIndianPriceWithComa(Math.abs(parseFloat(totalValue)).toFixed(2))}
                  </h5>
                </div>
              </div>



              <div className="col-md-6">
                {type == "UPI" && <div>
                 <label htmlFor="" className="px-1" style={{fontWeight:'500'}}>UPI Id</label>
                 <input
                  type="text"
                  value={upiid}
                  onChange={(e)=>{setupiid(e.target.value)}}
                  placeholder="UPI Id"
                  className="form-control mb-3 fw-semibold newfontsize"
                />
                </div>}
                

                {type == "CreditCard" && <div>
                 <label htmlFor="" style={{fontWeight:'500'}} className="px-1">Card No.</label>
                 <input
                  type="text"
                  value={cardno}
                  onChange={(e)=>{setcardno(e.target.value)}}
                  placeholder="Card No."
                  className="form-control mb-3 fw-semibold newfontsize"
                />
                </div>}
                

                {type == "Cheque" && <div>
                 <label htmlFor="" style={{fontWeight:'500'}} className="px-1">Cheque Reference No.</label>
                 <input
                  type="text"
                  value={CRN}
                  onChange={(e)=>{setCRN(e.target.value)}}
                  placeholder="Cheque Reference No."
                  className="form-control mb-2 fw-semibold newfontsize"
                />
                </div>}
                

                {type == "Cheque" && <div>
                 <label htmlFor="" style={{fontWeight:'500'}} className="px-1">Cheque Reference Date</label>
                 <input
                  type="date"
                  value={CRD}
                  onChange={(e)=>{setCRD(e.target.value)}}
                  placeholder="Cheque Reference Date"
                  className="form-control mb-3 fw-semibold newfontsize"
                />
                </div>}
                

                {type == "Old Gold" && <div>
                 <label htmlFor="" style={{fontWeight:'500'}} className="px-1">Account Paid To</label>
                 <input
                  type="text"
                  value={OldGold}
                  onChange={(e)=>{setOldGold(e.target.value)}}
                  placeholder="Account Paid To"
                  className="form-control mb-3 fw-semibold newfontsize"
                />
                </div>}

                

                 <input
                  type="text"
                  value={amountPaid}
                  readOnly
                  placeholder="Enter Amount"
                  className="form-control mb-3 fw-semibold newfontsize"
                />

                <div className="d-grid gap-2">
                  <div className="d-flex gap-2 w-100">
                        {[1, 2, 3].map((num) => (
                            <button
                            key={num}
                            className="btn btn-light flex-fill  fs-5 fw-semibold"
                            onClick={() => handleNumberClick(num.toString())}
                            >
                            {num}
                            </button>
                        ))}
                        </div>
                  <div className="d-flex gap-2 w-100">
                        {[4, 5, 6].map((num) => (
                            <button
                            key={num}
                            className="btn btn-light flex-fill fs-5 fw-semibold"
                            onClick={() => handleNumberClick(num.toString())}
                            >
                            {num}
                            </button>
                        ))}
                 </div>
                  <div className="d-flex gap-2 w-100">
                        {[7, 8, 9].map((num) => (
                            <button
                            key={num}
                            className="btn btn-light flex-fill fs-5 fw-semibold"
                            onClick={() => handleNumberClick(num.toString())}
                            >
                            {num}
                            </button>
                        ))}
                        </div>


                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-light flex-fill fw-semibold"
                      onClick={() => handleNumberClick("0")}
                    >
                      0
                    </button>
                    <button
                      className="btn btn-light flex-fill fw-semibold"
                      onClick={() => handleNumberClick(".")}
                    >
                      .
                    </button>
                    <button
                      style={{backgroundColor:'#ffc720'}}
                      className=" flex-fill yellowbghere hoverflow"
                      onClick={handleBackspace}
                    >
                      ⌫
                    </button>
                  </div>
                  <button
                  style={{backgroundColor:'#26AE58',color:'white'}}
                    className="hoverflow"
                    onClick={handleConfirm}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>

    
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
